import React, { ReactNode, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useMount } from '@mail/m-hooks';

import { getRepairAccount } from '../../../apis/Global';
import { getAccountStatus } from '../../../apis/MethodList';
import GlobalAction from '../../..//store/actions/global';

import {getQueryString} from '../../../utils/common';
import { RISK_CONTROL } from '../../../common/constant';

const WithAccountStatus = (com: ReactNode, withAccount: boolean, withStatus: boolean, withPhone: boolean) => {
    
    const AccountStatus: React.FC = () => {
        const dispatch = useDispatch();
        const history = useHistory();
        const location = useLocation();
        const { repairAccount, hasStatus, bindPhone } = useSelector((state: any) => state.global)

        // 是否正在申诉
        const explaining = useMemo(() => getQueryString('explaining', location.search), [location]);
        useMount(async () => {
            let account = repairAccount;
            // 全局一次
            if ((!account && withAccount) || (!bindPhone && withPhone)) {
                const res = await getRepairAccount();
                if (res && res.code === 200) {
                    dispatch({
                        type: GlobalAction.UPDATE_REPAIR_ACCOUNT,
                        playload: res?.result?.uid
                    })
                    dispatch({
                        type: GlobalAction.UPDATE_IF_PAY_USER,
                        playload: res?.result?.payUser
                    })
                    dispatch({
                        type: GlobalAction.UPDATE_ORIGINALUID,
                        playload: res?.result?.originalUid
                    })
                    dispatch({
                        type: GlobalAction.UPDATE_BIND_PHONE,
                        playload: res?.result?.bindPhone,
                    })
                    res?.result?.originalUid && (window as any).mailStats.setAccount(res?.result?.originalUid)
                    res?.result?.originalUid && (window as any).mailStats.setUid(res?.result?.originalUid);
                    account = res?.result?.uid;
                }
            }
            if (!hasStatus && withStatus) {
                const accountStatusRes = await getAccountStatus();
                if (accountStatusRes && accountStatusRes.code === 200) {
                    // 全局一次
                    dispatch({
                        type: GlobalAction.UPDATE_HAS_STATUS,
                        playload: true
                    })
                    
                    const { inRepair, phone, existMultiPhone } = accountStatusRes.result || {};

                    dispatch({
                        type: GlobalAction.UPDATE_IN_REPAIR,
                        playload: inRepair
                    })
                    if (inRepair && !explaining) {
                        history.push({
                            pathname: '/inquire',
                            search: `?uid=${account}` + (phone ? `&phone=${phone}` : '') + (existMultiPhone ? `&existMultiPhone=1` : '')
                        })
                    } else if (!inRepair && window.location.hash.indexOf('inquire') > -1 &&  window.location.hash.indexOf('inquireResult') === -1) {
                        // 不存在正在进行的任务，直接访问查询页，跳到统一错误页
                        history.push({
                            pathname: '/result',
                            search: `?status=${RISK_CONTROL}&riskText=${encodeURI('重置申请任务已结束')}&noAutoLink=1`
                        })
                    }
                }
            }
        })
        return (
            <>
                { com }
            </>
        )
    }
    return AccountStatus;
}

export default WithAccountStatus;
